import { render, staticRenderFns } from "./ManageOrders.vue?vue&type=template&id=e49d3ec2"
import script from "./ManageOrders.vue?vue&type=script&lang=js"
export * from "./ManageOrders.vue?vue&type=script&lang=js"
import style0 from "./ManageOrders.vue?vue&type=style&index=0&id=e49d3ec2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports